// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Simple Profile Card */
body {
    margin: 0;
    font-family: Arial, sans-serif;
    background-color: white;
}

.page {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.card {
    background-color: #f0f8ff;
    border-radius: 10px;
    padding: 40px;
    text-align: center;
    width: 500px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}

.avatar {
    height: 150px;
    width: 150px;
    border-radius: 10px;
    object-fit: cover;
    margin-bottom: 15px;
}

h1 {
    margin: 10px 0 5px;
    font-size: 22px;
}

h2 {
    margin: 0 0 15px;
    font-size: 16px;
    color: #555;
}

.bio {
    font-size: 14px;
    margin: 0 0 20px;
    line-height: 1.4;
    text-align: left;
}

.link {
    display: inline-block;
    padding: 8px 12px;
    background-color: #007acc;
    color: white;
    text-decoration: none;
    border-radius: 5px;
}

.link:hover {
    background-color: #005fa3;
}
  `, "",{"version":3,"sources":["webpack://./src/css/main.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;IACI,SAAS;IACT,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["/* Simple Profile Card */\nbody {\n    margin: 0;\n    font-family: Arial, sans-serif;\n    background-color: white;\n}\n\n.page {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n}\n\n.card {\n    background-color: #f0f8ff;\n    border-radius: 10px;\n    padding: 40px;\n    text-align: center;\n    width: 500px;\n    box-shadow: 0 4px 8px rgba(0,0,0,0.2);\n}\n\n.avatar {\n    height: 150px;\n    width: 150px;\n    border-radius: 10px;\n    object-fit: cover;\n    margin-bottom: 15px;\n}\n\nh1 {\n    margin: 10px 0 5px;\n    font-size: 22px;\n}\n\nh2 {\n    margin: 0 0 15px;\n    font-size: 16px;\n    color: #555;\n}\n\n.bio {\n    font-size: 14px;\n    margin: 0 0 20px;\n    line-height: 1.4;\n    text-align: left;\n}\n\n.link {\n    display: inline-block;\n    padding: 8px 12px;\n    background-color: #007acc;\n    color: white;\n    text-decoration: none;\n    border-radius: 5px;\n}\n\n.link:hover {\n    background-color: #005fa3;\n}\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
